/**
 * @ Author: Your name
 * @ Create Time: 2019-05-31 13:44:08
 * @ Modified by: Your name
 * @ Modified time: 2019-05-31 15:57:40
 * @ Description: 用户名的加密
 */
import CryptoJS from 'crypto-js'

const AES_CRYPT = {
  USER: {
    key: '1234567890abcdef',
    iv: '1dd89`X3nVfmchm?'
  },
  TOKEN: {
    key: '1234567890abcdef',
    iv: '1dd89`X3nVfmchm?'
  }
}

// 加密
export function aesEncrypt(str, type) {
  // eslint-disable-next-line no-underscore-dangle
  const type__ = type || 'TOKEN'
  // eslint-disable-next-line no-underscore-dangle
  const key = CryptoJS.enc.Latin1.parse(AES_CRYPT[type__].key)
  // eslint-disable-next-line no-underscore-dangle
  const iv = CryptoJS.enc.Latin1.parse(AES_CRYPT[type__].iv)

  return CryptoJS.AES.encrypt(str, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  }).toString()
}

// 解密
export function aesDecrypt(encrypted, type) {
  // eslint-disable-next-line no-underscore-dangle
  const type__ = type || 'TOKEN'
  // eslint-disable-next-line no-underscore-dangle
  const key = CryptoJS.enc.Latin1.parse(AES_CRYPT[type__].key)
  // eslint-disable-next-line no-underscore-dangle
  const iv = CryptoJS.enc.Latin1.parse(AES_CRYPT[type__].iv)

  return CryptoJS.AES.decrypt(encrypted, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  }).toString(CryptoJS.enc.Utf8)
}
